import React from 'react';
import { Clock, TrendingUp, BrainCircuit } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-468">
      <div className="max-w-4xl mx-auto" data-id="element-469">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-12 text-center" data-id="element-470">
          ⏰ Por Qué Decidir Ahora
        </h2>

        <div className="space-y-8" data-id="element-471">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-urgency flex flex-col md:flex-row gap-6 items-start" data-id="element-472">
            <div className="bg-urgency/10 p-4 rounded-full shrink-0" data-id="element-473">
              <TrendingUp className="text-urgency" size={32} data-id="element-474" />
            </div>
            <div data-id="element-475">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-476">
                Razón #1: El Precio Sube
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-477">
                Este es el precio de lanzamiento. Una vez que se superen las
                primeras unidades vendidas, el precio vuelve a $29 USD. No es un
                truco de marketing. Es la política de lanzamiento real.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-forest flex flex-col md:flex-row gap-6 items-start" data-id="element-478">
            <div className="bg-forest/10 p-4 rounded-full shrink-0" data-id="element-479">
              <Clock className="text-forest" size={32} data-id="element-480" />
            </div>
            <div data-id="element-481">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-482">
                Razón #2: Cada Noche Que Pasa Es Una Noche Perdida
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-483">
                La inflamación crónica no toma días libres. Cada noche que cenas
                de la misma manera, acumulas un ciclo inflamatorio más. El mejor
                momento para empezar fue hace un año. El segundo mejor momento
                es esta noche.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-gold flex flex-col md:flex-row gap-6 items-start" data-id="element-484">
            <div className="bg-gold/20 p-4 rounded-full shrink-0" data-id="element-485">
              <BrainCircuit className="text-gold-dark" size={32} data-id="element-486" />
            </div>
            <div data-id="element-487">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-488">
                Razón #3: Tu Cuerpo Tiene Memoria
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-489">
                Cuanto más tiempo permanece el sistema inflamatorio activado,
                más tiempo tarda en regularse. Empezar hoy significa resultados
                esta semana. Esperar un mes significa empezar desde más atrás.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}